/* Vetalogica native Impulse drawer enhancement, stage 1. No promotion is awarded client-side. */
(function(){
  'use strict';
  var drawer=document.getElementById('CartDrawer');
  if(!drawer)return;
  // Gift details are optional disclosure only; this does not change cart contents.
  drawer.addEventListener('click',function(e){
    var trigger=e.target.closest('[data-veta-gift-disclosure]');
    if(!trigger || trigger.hidden)return;
    var expanded=trigger.getAttribute('aria-expanded')==='true';
    trigger.setAttribute('aria-expanded',String(!expanded));
    var details=drawer.querySelector('[data-veta-gift-preview]');
    if(details)details.hidden=expanded;
  });
  var money=function(cents){return new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'}).format(cents/100)};
  var inFlight=false,again=false;
  var protectionVariantId=67727263924472;
  var protectionCleanupBusy=false;
  var cartEndpoint=function(path){return (window.Shopify && Shopify.routes && Shopify.routes.root || '/')+path;};
  async function cartPost(path,payload){
    var response=await fetch(cartEndpoint(path),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
    if(!response.ok){var details=await response.json().catch(function(){return {description:'HTTP '+response.status};});throw new Error(details.description||details.message||'HTTP '+response.status);}return response.json();
  }
  // Stage 49: no protection upsell. Remove legacy protection lines from existing carts.
  async function removeLegacyProtection(){
    if(protectionCleanupBusy)return;
    protectionCleanupBusy=true;
    try{
      var response=await fetch(cartEndpoint('cart.js'),{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)return;
      var cart=await response.json();
      var lines=cart.items.filter(function(item){return Number(item.variant_id)===protectionVariantId;});
      if(!lines.length)return;
      for(var i=0;i<lines.length;i++)await cartPost('cart/change.js',{id:lines[i].key,quantity:0});
      document.dispatchEvent(new CustomEvent('cart:build'));
      await refresh();
    }catch(error){console.warn('Could not remove previous shipping protection',error);}
    finally{protectionCleanupBusy=false;}
  }
  document.addEventListener('cart:open',function(){setTimeout(removeLegacyProtection,100);});
  document.addEventListener('ajaxProduct:added',function(){setTimeout(removeLegacyProtection,200);});
  var giftSyncBusy=false;
  var giftRetrySignature='';
  var giftRetryAt=0;
  var giftRetryCount=0;
  var giftRetryTimer=null;
  function scheduleGiftRecheck(delay){
    if(giftRetryTimer)clearTimeout(giftRetryTimer);
    giftRetryTimer=setTimeout(function(){giftRetryTimer=null;refresh();},delay);
  }
  function giftLine(item){return item.properties && String(item.properties._vetalogica_gift)==='true';}
  function giftSettings(){
    try{return JSON.parse((drawer.querySelector('#VetaGiftConfig')||{}).textContent||'{}');}
    catch(e){return {};}
  }
  async function syncGift(cart,config,qualifying){
    if(giftSyncBusy)return false;
    var managed=cart.items.filter(giftLine);
    var shouldAdd=config.enabled&&config.configured&&config.available&&config.eligibility==='all'&&qualifying>=Number(config.threshold||10000);
    // A later qualifying cart state must be allowed to earn the gift again.
    if(!shouldAdd){giftRetrySignature='';giftRetryAt=0;giftRetryCount=0;if(giftRetryTimer){clearTimeout(giftRetryTimer);giftRetryTimer=null;}}
    // Only remove our own promotional lines. Never remove a normally purchased gift SKU.
    var invalid=managed.filter(function(i){return !shouldAdd||Number(i.variant_id)!==Number(config.variantId)||Number(i.final_line_price)>0;});
    if(managed.length>1||managed.some(function(i){return i.quantity!==1;}))invalid=managed.slice();
    if(invalid.length){
      giftSyncBusy=true;
      try{for(var item of invalid)await cartPost('cart/change.js',{id:item.key,quantity:0});}
      finally{giftSyncBusy=false;}
      giftRetrySignature='';giftRetryAt=0;giftRetryCount=0;
      document.dispatchEvent(new CustomEvent('cart:build'));
      return true;
    }
    if(!shouldAdd||managed.length){if(managed.length){giftRetrySignature='';giftRetryAt=0;giftRetryCount=0;}return false;}
    // Avoid retrying endlessly if the merchant's Buy X Get Y discount is not valid.
    var signature=String(config.variantId)+'|'+String(qualifying)+'|'+cart.items.map(function(i){return i.key+':'+i.quantity;}).join(',');
    // Debounce only immediate repeat attempts, not the customer's next quantity change.
    if(giftRetrySignature!==signature)giftRetryCount=0;
    if(giftRetrySignature===signature && giftRetryCount>=3)return false;
    if(giftRetrySignature===signature && Date.now()-giftRetryAt<1500){scheduleGiftRecheck(1600);return false;}
    giftRetrySignature=signature;giftRetryAt=Date.now();giftRetryCount++;
    giftSyncBusy=true;
    try{
      await cartPost('cart/add.js',{items:[{id:Number(config.variantId),quantity:1,properties:{_vetalogica_gift:'true'}}]});
      var after=await(await fetch(cartEndpoint('cart.js'),{credentials:'same-origin',cache:'no-store'})).json();
      var added=after.items.filter(giftLine);
      // If Shopify has not made the item free, do not leave a paid surprise in checkout.
      if(added.some(function(i){return Number(i.final_line_price)>0;})){
        for(var line of added)await cartPost('cart/change.js',{id:line.key,quantity:0});
        var error=drawer.querySelector('[data-veta-cart-error]');
        if(error)error.textContent='Free gift could not be applied with the current discounts. No gift has been charged.';
        // Discounts may be recalculated after the first Ajax response. Retry shortly.
        scheduleGiftRecheck(1800);
      }
      document.dispatchEvent(new CustomEvent('cart:build'));
      return true;
    }catch(e){console.warn('Vetalogica gift could not be added',e);scheduleGiftRecheck(1800);return false;}
    finally{giftSyncBusy=false;}
  }
  function updateUpsellArrows(section){
    if(!section)return;
    var grid=section.querySelector('[data-veta-upsells-grid]');
    var controls=section.querySelector('[data-veta-upsell-controls]');
    if(!grid||!controls)return;
    var cards=Array.from(grid.querySelectorAll('[data-veta-recommendation]')).filter(function(el){return !el.hidden;});
    var visibleSlots=window.matchMedia('(max-width: 749px)').matches?1:2;
    controls.hidden=cards.length<=visibleSlots;
    var prev=controls.querySelector('[data-veta-upsell-prev]');
    var next=controls.querySelector('[data-veta-upsell-next]');
    if(prev)prev.disabled=grid.scrollLeft<=2;
    if(next)next.disabled=grid.scrollLeft+grid.clientWidth>=grid.scrollWidth-2;
  }
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-veta-upsell-prev],[data-veta-upsell-next]');
    if(!btn||!drawer.contains(btn))return;
    var section=btn.closest('[data-veta-upsells]');
    var grid=section&&section.querySelector('[data-veta-upsells-grid]');
    if(!grid)return;
    var card=grid.querySelector('[data-veta-recommendation]:not([hidden])');
    var step=card?card.getBoundingClientRect().width+10:grid.clientWidth;
    grid.scrollBy({left:step*(btn.hasAttribute('data-veta-upsell-next')?1:-1),behavior:'smooth'});
  });
  document.addEventListener('scroll',function(e){
    var grid=e.target;
    if(grid&&grid.matches&&grid.matches('[data-veta-upsells-grid]'))updateUpsellArrows(grid.closest('[data-veta-upsells]'));
  },true);
  window.addEventListener('resize',function(){updateUpsellArrows(drawer.querySelector('[data-veta-upsells]'));});
  async function refresh(){
    if(inFlight){again=true;return;}inFlight=true;
    try{
      var response=await fetch(cartEndpoint('cart.js'),{credentials:'same-origin',cache:'no-store'});
      if(!response.ok)throw new Error('Cart fetch failed');
      var cart=await response.json();
      // Section Rendering API evaluates cart-item product metafields on every cart change.
      var upsellHost=drawer.querySelector('[data-veta-upsells-host]');
      if(upsellHost){
        try{
          var sectionsResponse=await fetch(cartEndpoint('?sections=veta-cart-upsells'),{credentials:'same-origin',cache:'no-store'});
          if(!sectionsResponse.ok)throw new Error('Recommendations unavailable');
          var sectionsData=await sectionsResponse.json();
          var upsellMarkup=sectionsData['veta-cart-upsells'];
          if(typeof upsellMarkup==='string'){
            var temp=document.createElement('div');temp.innerHTML=upsellMarkup;
            var fresh=temp.querySelector('[data-veta-upsells]');
            upsellHost.replaceChildren();if(fresh)upsellHost.appendChild(fresh);
          }
        }catch(err){console.warn('Could not update cart add-ons',err);}
      }
      var upsells=drawer.querySelector('[data-veta-upsells]');
      if(upsells){
        var goodsForUpsell=cart.items.filter(function(i){return Number(i.variant_id)!==protectionVariantId&&!giftLine(i);});
        var cartIds=new Set(cart.items.map(function(i){return String(i.product_id)}));
        var cartNames=goodsForUpsell.map(function(i){return String(i.product_title||i.title||'').toLowerCase()}).join(' ');
        var dogCart=/\bdog\b|canine|puppy/.test(cartNames),catCart=/\bcat\b|feline|kitten/.test(cartNames);
        var visible=0;
        var seenUpsellIds=new Set();
        upsells.querySelectorAll('[data-veta-recommendation]').forEach(function(card){
          var name=(card.getAttribute('data-product-title')+' '+card.getAttribute('data-product-type')+' '+card.getAttribute('data-product-tags')).toLowerCase();
          var dogProduct=/\bdog\b|canine|puppy/.test(name),catProduct=/\bcat\b|feline|kitten/.test(name);
          var wrongSpecies=(dogCart&&!catCart&&catProduct&&!dogProduct)||(catCart&&!dogCart&&dogProduct&&!catProduct);
          var productId=card.getAttribute('data-product-id');
          var show=goodsForUpsell.length>0&&!cartIds.has(productId)&&!seenUpsellIds.has(productId)&&!wrongSpecies&&visible<2;
          card.hidden=!show;if(show){seenUpsellIds.add(productId);visible++;}
        });
        upsells.hidden=visible===0;
        // Stage 28: only display navigation if there are additional eligible cards.
        updateUpsellArrows(upsells);
      }
      var merchandise=cart.items.filter(function(i){return !giftLine(i)&&Number(i.variant_id)!==protectionVariantId;}).reduce(function(sum,i){return sum+i.final_line_price},0);
      // Promotional spend excludes the free gift; legacy protection is removed from carts.
      var progress=drawer.querySelector('[data-veta-progress]');
      if(progress){progress.style.width=Math.min(100,merchandise/10000*100)+'%';progress.parentElement.setAttribute('aria-valuenow',String(Math.min(100,Math.round(merchandise/10000*100))));}
      var msg=drawer.querySelector('[data-veta-rewards-message]');
      var gift=drawer.querySelector('[data-veta-gift-preview]');
      var giftConfig=giftSettings();
      var giftEnabled=!!(giftConfig.enabled&&giftConfig.configured&&giftConfig.eligibility==='all');
      var giftThreshold=Number(giftConfig.threshold)||10000;
      var managedGift=cart.items.filter(giftLine);
      var giftFree=managedGift.length===1&&Number(managedGift[0].final_line_price)===0;
      if(gift){
        var giftDisclosure=drawer.querySelector('[data-veta-gift-disclosure]');
        var giftDisclosureLabel=drawer.querySelector('[data-veta-gift-disclosure-label]');
        if(giftDisclosureLabel){var giftValueCents=Number(giftConfig.rrpCents)||0;giftDisclosureLabel.textContent=giftValueCents>0?'Unlock your FREE '+money(giftValueCents)+' gift':'Unlock your FREE gift';}
        // A qualifying free gift already appears in the cart items; don't duplicate its tile.
        var showGiftDetails=giftEnabled && !giftFree;
        if(giftDisclosure){
          giftDisclosure.hidden=!showGiftDetails;
          giftDisclosure.setAttribute('aria-expanded',String(giftDisclosure.getAttribute('aria-expanded')==='true' && showGiftDetails));
        }
        gift.hidden=!(showGiftDetails && giftDisclosure && giftDisclosure.getAttribute('aria-expanded')==='true');
        if(giftEnabled){
          var image=gift.querySelector('[data-veta-gift-image]');
          if(image){image.hidden=!giftConfig.image;if(giftConfig.image)image.src=giftConfig.image;}
          var title=gift.querySelector('[data-veta-gift-name]');if(title)title.textContent=giftConfig.title;
          var heading=gift.querySelector('[data-veta-gift-heading]');if(heading)heading.textContent=giftConfig.heading||'This month’s free gift';
          var description=gift.querySelector('[data-veta-gift-description]');if(description)description.textContent=giftConfig.description||'';
          var rrp=gift.querySelector('[data-veta-gift-rrp]');var freeLabel=gift.querySelector('[data-veta-gift-free]');var rrpCents=Number(giftConfig.rrpCents)||0;if(rrp){rrp.hidden=!rrpCents;if(rrpCents)rrp.textContent='RRP '+money(rrpCents);}if(freeLabel)freeLabel.hidden=!rrpCents;
          var note=gift.querySelector('[data-veta-gift-message]');
          if(note)note.textContent=merchandise>=giftThreshold?(giftFree?'Added free to your cart':giftConfig.available?'Checking gift eligibility…':'Gift currently unavailable'):'Spend '+money(giftThreshold-merchandise)+' more to unlock';
        }
      }
      var giftMilestoneVisibility=drawer.querySelector('[data-veta-gift-milestone]');
      if(giftMilestoneVisibility){giftMilestoneVisibility.hidden=!giftEnabled;var thresholdLabel=giftMilestoneVisibility.querySelector('[data-veta-gift-threshold]');if(thresholdLabel)thresholdLabel.textContent=money(giftThreshold).replace('.00','');}
      var rewards=drawer.querySelector('[data-veta-rewards]');if(rewards)rewards.classList.toggle('veta-rewards--shipping-only',!giftEnabled);
      if(progress){var max=giftEnabled?giftThreshold:5000;progress.style.width=Math.min(100,merchandise/max*100)+'%';progress.parentElement.setAttribute('aria-valuemax',String(max/100));progress.parentElement.setAttribute('aria-valuenow',String(Math.min(max,merchandise)/100));progress.parentElement.setAttribute('aria-label',giftEnabled?'Progress towards free gift':'Progress towards free shipping');}
      var countHeading=drawer.querySelector('[data-veta-heading-count]');
      if(countHeading)countHeading.textContent='('+cart.items.filter(function(i){return Number(i.variant_id)!==protectionVariantId&&!((i.properties||{})._vetalogica_gift);}).reduce(function(n,i){return n+i.quantity},0)+')';
      var productCache={};
      await Promise.all(cart.items.filter(function(i){return Number(i.variant_id)!==protectionVariantId}).map(async function(i){
        if(productCache[i.handle]!==undefined)return;
        productCache[i.handle]=null;
        try{
          var p=await fetch(cartEndpoint('products/'+i.handle+'.js'),{credentials:'same-origin'});
          if(p.ok)productCache[i.handle]=await p.json();
        }catch(e){}
      }));
      // Shipping eligibility is determined exclusively from the free-shipping
      // product tag, not example product IDs or a manually maintained allowlist.
      // /products/{handle}.js exposes the product's public tags.
      var goods=cart.items.filter(function(i){return Number(i.variant_id)!==protectionVariantId && !((i.properties||{})._vetalogica_gift);});
      function isTaggedFreeShipping(item){
        var product=productCache[item.handle];
        if(!product)return null; // unknown: never assume free shipping
        var tags=product.tags||[];
        if(typeof tags==='string')tags=tags.split(',');
        return Array.isArray(tags) && tags.some(function(tag){return String(tag).trim().toLowerCase()==='free-shipping';});
      }
      // Merchant-confirmed store policy: any tagged merchandise OR a merchandise
      // total of at least $50 qualifies the whole cart.
      // Promotional gifts do not count toward the threshold.
      var anyTagged=goods.some(function(item){return isTaggedFreeShipping(item)===true;});
      var freeShippingUnlocked=goods.length>0 && (anyTagged || merchandise>=5000);
      var shippingMilestone=drawer.querySelector('[data-veta-shipping-milestone]');
      var shippingStatus=drawer.querySelector('[data-veta-shipping-status]');
      var giftMilestone=drawer.querySelector('[data-veta-gift-milestone]');
      if(shippingMilestone)shippingMilestone.classList.toggle('is-unlocked',freeShippingUnlocked);
      if(shippingStatus)shippingStatus.textContent=freeShippingUnlocked?'FREE SHIPPING ✓':'FREE SHIPPING';
      var shippingThresholdLabel=shippingMilestone&&shippingMilestone.querySelector('small');
      if(shippingThresholdLabel)shippingThresholdLabel.textContent=anyTagged?'Unlocked':'$50';
      if(giftMilestone)giftMilestone.classList.toggle('is-unlocked',giftEnabled&&merchandise>=giftThreshold);
      if(msg){
        if(!goods.length)msg.textContent='Shipping '+money(5000)+' away';
        else if(!freeShippingUnlocked)msg.textContent='Shipping '+money(Math.max(0,5000-merchandise))+' away';
        else if(giftEnabled && merchandise<giftThreshold)msg.textContent='Gift '+money(giftThreshold-merchandise)+' away';
        else if(giftEnabled && merchandise>=giftThreshold)msg.textContent='Shipping + gift unlocked';
        else msg.textContent='Free shipping unlocked';
      }
      // Synchronise only after shipping calculations, avoiding re-entrant Ajax updates.
      if(!giftSyncBusy){
        var changed=await syncGift(cart,giftConfig,merchandise);
        if(changed){again=true;return;}
      }
      var savings=cart.items.reduce(function(sum,item){
        if(Number(item.variant_id)===protectionVariantId||giftLine(item))return sum;
        var p=productCache[item.handle];
        var v=p && p.variants && p.variants.find(function(v){return Number(v.id)===Number(item.variant_id)});
        var compare=Number(v && v.compare_at_price||0)*item.quantity;
        var regular=Number(v && v.price||0)*item.quantity;
        var original=Number(item.original_line_price||0);
        var baseline=Math.max(compare,original,regular);
        return sum+Math.max(0,baseline-Number(item.final_line_price||0));
      },0);
      var lineFinal=cart.items.reduce(function(n,i){return n+Number(i.final_line_price||0);},0);
      savings+=Math.max(0,lineFinal-Number(cart.total_price||0));
      var savingsRow=drawer.querySelector('[data-veta-savings-row]');
      if(savingsRow){savingsRow.hidden=savings===0;var sv=savingsRow.querySelector('[data-veta-savings]');if(sv)sv.textContent=money(savings);}
      var count=cart.items.filter(function(i){return Number(i.variant_id)!==protectionVariantId && !(i.properties&&i.properties._vetalogica_gift);}).reduce(function(n,i){return n+i.quantity;},0);
      // Stage 35: show the live cart total only inside the checkout button.
      var checkoutTotal=drawer.querySelector('[data-veta-checkout-total]');
      if(checkoutTotal)checkoutTotal.textContent='· '+money(cart.total_price);
    }catch(err){console.warn('Vetalogica cart summary unavailable',err);}
    finally{inFlight=false;if(again){again=false;refresh();}}
  }
  // One-time to subscription conversion: use real product selling-plan IDs and
  // replace the original line only after the subscribed line is successfully added.
  var modal=drawer.querySelector('[data-veta-plan-modal]');
  var activePlan=null;
  // Resolve stale cart keys without guessing when duplicate variants are present.
  async function currentCart(){
    var response=await fetch(cartEndpoint('cart.js'),{credentials:'same-origin',cache:'no-store'});
    if(!response.ok)throw Error('Unable to refresh the cart');
    return response.json();
  }
  function resolveOneTimeItem(cart,key,variantId){
    var direct=cart.items.find(function(i){return i.key===key && !i.selling_plan_allocation;});
    if(direct)return direct;
    var matches=cart.items.filter(function(i){return Number(i.variant_id)===Number(variantId) && !i.selling_plan_allocation;});
    return matches.length===1?matches[0]:null;
  }

  function closePlan(){if(modal)modal.hidden=true;activePlan=null;}
  var closeButton=drawer.querySelector('[data-veta-plan-close]');
  if(closeButton)closeButton.addEventListener('click',closePlan);
  if(modal)modal.addEventListener('click',function(e){if(e.target===modal)closePlan();});
  drawer.addEventListener('click',async function(e){
    var link=e.target.closest('[data-veta-subscribe]');if(!link)return;
    e.preventDefault();e.stopPropagation();
    var error=drawer.querySelector('[data-veta-plan-error]');if(error)error.textContent='';
    var selector=drawer.querySelector('[data-veta-plan-select]');
    var price=drawer.querySelector('[data-veta-plan-price]');
    try{
      var r=await fetch(cartEndpoint('products/'+encodeURIComponent(link.getAttribute('data-product-handle'))+'.js'),{credentials:'same-origin'});
      if(!r.ok)throw Error('Unable to load delivery plans');
      var product=await r.json();
      var plans=(product.selling_plan_groups||[]).flatMap(function(g){return g.selling_plans||[]});
      if(!plans.length)throw Error('Auto Delivery is not available for this product');
      var cart=await currentCart();
      var item=resolveOneTimeItem(cart,link.getAttribute('data-line-key'),link.getAttribute('data-variant-id'));
      if(!item)throw Error('Could not identify this item safely. Reopen the cart and try again.');
      var variant=(product.variants||[]).find(function(v){return Number(v.id)===Number(item.variant_id)});
      activePlan={key:item.key,variantId:item.variant_id,quantity:item.quantity,properties:item.properties||{},plans:plans,price:variant?variant.price:item.original_price};
      selector.textContent='';
      plans.forEach(function(plan){var option=document.createElement('option');option.value=plan.id;option.textContent=plan.name;selector.appendChild(option);});
      function updatePlanQuote(){
        var selected=plans.find(function(p){return String(p.id)===selector.value});
        if(!selected||!price)return;
        var adj=(selected.price_adjustments||[])[0];
        if(!adj){price.textContent='Subscription price shown at checkout';return;}
        var kind=adj.value_type, value=Number(adj.value);
        var base=Number(activePlan.price);
        if(!Number.isFinite(value)||!Number.isFinite(base)||base<=0){price.textContent='Subscription price shown at checkout';return;}
        var amount=kind==='percentage'?Math.round(base*(100-value)/100):kind==='fixed_amount'?Math.max(0,base-value):kind==='price'?value:null;
        if(amount===null){price.textContent='Subscription price shown at checkout';return;}
        var saving=Math.max(0,base-amount);
        var percentage=kind==='percentage'?value:Math.round(saving/base*100);
        price.textContent=money(amount)+' per item'+(percentage>0?' · Save '+percentage+'% ('+money(saving)+')':'');
      }
      selector.onchange=updatePlanQuote;
      updatePlanQuote();
      if(modal)modal.hidden=false;
    }catch(err){if(error)error.textContent=err.message; if(modal)modal.hidden=false;}
  });
  var confirm=drawer.querySelector('[data-veta-plan-confirm]');
  if(confirm)confirm.addEventListener('click',async function(){
    if(!activePlan)return;
    var error=drawer.querySelector('[data-veta-plan-error]');
    var selector=drawer.querySelector('[data-veta-plan-select]');
    confirm.disabled=true;
    try{
      var planId=Number(selector.value);
      if(!activePlan.plans.some(function(p){return Number(p.id)===planId}))throw Error('Choose a valid delivery frequency');
      // Recheck immediately before converting; the cart may have changed while the modal was open.
      var latest=await currentCart();
      var original=resolveOneTimeItem(latest,activePlan.key,activePlan.variantId);
      if(!original)throw Error('This cart item changed. Reopen the cart and try again.');
      // If quantity/properties changed, use the latest live values.
      var originalQuantity=original.quantity;
      var originalProperties=original.properties||{};
      await cartPost('cart/add.js',{items:[{id:original.variant_id,quantity:originalQuantity,selling_plan:planId,properties:originalProperties}]});
      try{
        var afterAdd=await currentCart();
        var toRemove=resolveOneTimeItem(afterAdd,original.key,original.variant_id);
        if(!toRemove)throw Error('Original cart line is no longer identifiable');
        await cartPost('cart/change.js',{id:toRemove.key,quantity:0});
      }
      catch(removeError){
        // Avoid a double order if original line could not be removed.
        var c=await(await fetch(cartEndpoint('cart.js'),{credentials:'same-origin'})).json();
        var added=c.items.filter(function(i){return Number(i.variant_id)===Number(activePlan.variantId)&&i.selling_plan_allocation&&Number(i.selling_plan_allocation.selling_plan.id)===planId});
        // Only undo a uniquely identifiable subscribed line; never remove an ambiguous existing subscription.
        if(added.length===1)await cartPost('cart/change.js',{id:added[0].key,quantity:0});
        throw Error('Could not complete Auto Delivery. Please review your cart before checkout.');
      }
      closePlan();document.dispatchEvent(new CustomEvent('cart:build'));await refresh();
    }catch(err){if(error)error.textContent=err.message;}
    finally{confirm.disabled=false;}
  });
  drawer.addEventListener('click',async function(e){
    var b=e.target.closest('[data-veta-upsell-add]');if(!b)return;
    e.preventDefault();b.disabled=true;
    try{await cartPost('cart/add.js',{items:[{id:Number(b.getAttribute('data-variant-id')),quantity:1}]});document.dispatchEvent(new CustomEvent('cart:build'));await refresh();}
    catch(err){var area=drawer.querySelector('[data-veta-cart-error]');if(area)area.textContent=err.message;}
    finally{b.disabled=false;}
  });
  // Independent line controls, identified by the exact cart line key.
  var lineBusy=false;
  drawer.addEventListener('click',async function(event){
    var button=event.target.closest('[data-veta-qty], [data-veta-remove]');
    if(!button||!drawer.contains(button))return;
    event.preventDefault();event.stopPropagation();event.stopImmediatePropagation();
    if(lineBusy)return;
    var key=button.getAttribute('data-line-key');if(!key)return;
    lineBusy=true;button.disabled=true;
    try{
      var r=await fetch(cartEndpoint('cart.js'),{credentials:'same-origin',cache:'no-store'});
      if(!r.ok)throw new Error('Unable to read cart');
      var cart=await r.json();
      var item=cart.items.find(function(i){return i.key===key});
      if(!item)throw new Error('Cart item has changed; reopen the cart');
      var qty=button.hasAttribute('data-veta-remove')?0:Math.max(0,item.quantity+Number(button.getAttribute('data-veta-qty')||0));
      await cartPost('cart/change.js',{id:key,quantity:qty});
      document.dispatchEvent(new CustomEvent('cart:build'));
      await refresh();
    }catch(e){
      var err=drawer.querySelector('[data-veta-cart-error]');
      if(err)err.textContent=e.message||'Unable to update cart';
    }finally{lineBusy=false;button.disabled=false;}
  },true);
  var observer=new MutationObserver(function(changes){
    if(changes.some(function(c){return c.target.closest && c.target.closest('[data-products]')}))refresh();
  });
  var products=drawer.querySelector('[data-products]');if(products)observer.observe(products,{childList:true,subtree:false});
  document.addEventListener('ajaxProduct:added',refresh);
  document.addEventListener('cart:open',refresh);
  refresh();
  setTimeout(removeLegacyProtection,400);
})();

/* Stage 43: prevent the page beneath the drawer from scrolling on iOS Safari.
   Observe the native Impulse open class so all cart-open paths are covered. */
(function(){
  function init(){
    var drawer=document.getElementById('CartDrawer');
    if(!drawer || drawer.dataset.vetaScrollLockBound)return;
    drawer.dataset.vetaScrollLockBound='true';
    var locked=false, savedY=0;
    function sync(){
      var open=drawer.classList.contains('drawer--is-open');
      if(open===locked)return;
      locked=open;
      if(open){
        savedY=window.scrollY||window.pageYOffset||0;
        document.documentElement.classList.add('veta-cart-scroll-locked');
        document.body.classList.add('veta-cart-scroll-locked');
        document.body.style.position='fixed';
        document.body.style.top=(-savedY)+'px';
        document.body.style.left='0';
        document.body.style.right='0';
        document.body.style.width='100%';
      }else{
        document.documentElement.classList.remove('veta-cart-scroll-locked');
        document.body.classList.remove('veta-cart-scroll-locked');
        document.body.style.position='';
        document.body.style.top='';
        document.body.style.left='';
        document.body.style.right='';
        document.body.style.width='';
        window.scrollTo(0,savedY);
      }
    }
    new MutationObserver(sync).observe(drawer,{attributes:true,attributeFilter:['class']});
    sync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
